/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Create_Share_ButtonInputs */



/**
* | output |
* | --- |
* | "Create share" |
*
* @param {Team_Share_Create_Share_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_create_share_button = /** @type {((inputs?: Team_Share_Create_Share_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Create_Share_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Create share")
	if (locale === "de") return /** @type {LocalizedString} */ ("Create share")
	if (locale === "it") return /** @type {LocalizedString} */ ("Create share")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Create share")
	if (locale === "es") return /** @type {LocalizedString} */ ("Create share")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Create share")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Create share")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Create share")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Create share")
	return /** @type {LocalizedString} */ ("Create share")
});